
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sns",
      function () {
        return require("private-next-pages/sns.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sns"])
      });
    }
  